import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://intellusionai.com";
const OG_IMAGE = `${SITE}/og-image.png`;
const DEFAULT_DESC =
  "Intellusion builds intelligent systems that put institutional-grade intelligence in everyone's hands. Evidence over assumption. Every output traceable to its source.";

// Per-route metadata. Titles, descriptions and canonical paths live here so
// every page ships a unique <title>, meta description, canonical and social card.
const ROUTE_META = {
  "/": {
    title: "Intellusion · Intelligent Systems That Solve Real World Problems",
    desc: DEFAULT_DESC,
  },
  "/about": {
    title: "About · Intellusion",
    desc: "Our mission is to put institutional-grade intelligence in everyone's hands, and prove every answer back to its source.",
  },
  "/projects": {
    title: "Products · Intellusion",
    desc: "StockLens, MHX, NetworkX, Bill-y and iLab — five products that hand gated capabilities back to the people they were kept from.",
  },
  "/bill-y": {
    title: "Bill-y · Intellusion",
    desc: "Bill-y measures not how much AI your team uses, but how well — a monitoring layer that splits AI token spend across the phases of building software.",
  },
  "/use-cases": {
    title: "Use Cases · Intellusion",
    desc: "Where Intellusion's intelligence goes to work, from factory floors to financial markets and connected infrastructure.",
  },
  "/careers": {
    title: "Careers · Intellusion",
    desc: "Join a small team shipping intelligence people can actually use. See open roles at Intellusion.",
  },
  "/ilab": {
    title: "iLab · Intellusion",
    desc: "iLab is where Intellusion tests new ways to make AI more reliable, easier to check and safer to use — and publishes what it learns.",
  },
  "/contact": {
    title: "Contact · Intellusion",
    desc: "Tell us what you are building or what you need. We read every message and reply quickly.",
  },
  "/privacy": {
    title: "Privacy Policy · Intellusion",
    desc: "How Intellusion collects, uses and protects your information.",
  },
  "/terms": {
    title: "Terms of Service · Intellusion",
    desc: "The terms that govern your use of the Intellusion website.",
  },
  "/atc": {
    title: "ATC · Intellusion",
    desc: "ATC is a new Intellusion product. Coming soon.",
  },
  "/meg-o": {
    title: "Meg-O · Intellusion",
    desc: "Meg-O is a new Intellusion product. Coming soon.",
  },
  "/nofloat": {
    title: "NoFloat · Intellusion",
    desc: "NoFloat is a new Intellusion product. Coming soon.",
  },
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname];
    const known = Boolean(meta);
    const title = meta ? meta.title : "Intellusion";
    const desc = meta ? meta.desc : DEFAULT_DESC;
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;

    document.title = title;
    upsertMeta("name", "description", desc);
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", OG_IMAGE);

    // Twitter
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", OG_IMAGE);

    // Keep unknown routes (e.g. 404) out of the index
    upsertMeta("name", "robots", known ? "index, follow" : "noindex, follow");
  }, [pathname]);

  return null;
}

export default Seo;
